(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tg-sign-configurator"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('tg-sign-configurator')) return;

    const ZW = '​';

    class TgSignConfigurator extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        const $ = (r) => this.querySelector(`[data-ref="${r}"]`);
        this.board = $('board'); this.line = $('line'); this.dim = $('dim');
        this.editor = $('editor'); this.counter = $('counter'); this.total = $('total'); this.errorEl = $('error');
        this.grid = $('grid'); this.search = $('logosearch'); this.logoEmpty = $('logoempty');
        this.enforceMin = this.dataset.enforceMin !== 'false';
        this.countSpaces = this.dataset.countSpaces === 'true';
        this.upper = this.dataset.upper !== 'false';

        this.logos = {};
        this.grid.querySelectorAll('.tgc__pick').forEach((b) => {
          this.logos[b.dataset.id] = { name: b.dataset.name, r: b.style.getPropertyValue('--r').trim(), c: b.style.getPropertyValue('--c').trim() };
        });

        this.initVariants();
        this.editor.dataset.upper = String(this.upper);
        this.line.dataset.upper = String(this.upper);

        this.bindForm();
        this.bindEvents();
        this.update();
        if ('ResizeObserver' in window) new ResizeObserver(() => this.fit()).observe(this.board);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fit());
        setTimeout(() => this.syncVariant(), 300);
      }

      /* ---------- form ---------- */
      bindForm() {
        let form = document.getElementById(this.dataset.form);
        if (!form || form.tagName !== 'FORM') {
          const sec = this.closest('.shopify-section') || document;
          form = sec.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        }
        this.form = form;
        if (form) {
          // attenzione: form.id può restituire il campo <input name="id"> della variante, quindi uso gli attributi
          if (!form.getAttribute('id')) form.setAttribute('id', this.dataset.form);
          const fid = form.getAttribute('id');
          this.querySelectorAll('[data-prop]').forEach((i) => i.setAttribute('form', fid));
        }
        const guard = (e) => {
          if (!this.form || !this.isConnected) return;
          const t = e.target;
          if (!(t instanceof Element)) return;
          if (e.type === 'click') {
            const btn = t.closest('button[type="submit"], button[name="add"], add-to-cart-component button, [data-add-to-cart]');
            if (!btn || !this.form.contains(btn)) return;
          } else if (e.target !== this.form) return;
          const err = this.validate();
          if (err) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.showError(err);
            this.editor.scrollIntoView({ block: 'center', behavior: 'smooth' });
            this.editor.focus();
          }
        };
        document.addEventListener('click', guard, true);
        document.addEventListener('submit', guard, true);
      }

      /* ---------- eventi ---------- */
      bindEvents() {
        this.addEventListener('change', (e) => {
          if (e.target.matches('input[type="radio"]')) { this.update(); this.syncVariant(); }
        });

        document.addEventListener('selectionchange', () => {
          const s = document.getSelection();
          if (s && s.rangeCount && this.editor.contains(s.anchorNode)) this.range = s.getRangeAt(0).cloneRange();
        });

        this.editor.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') e.preventDefault();
        });
        this.editor.addEventListener('beforeinput', (e) => {
          const t = e.inputType;
          if (t === 'insertParagraph' || t === 'insertLineBreak') return e.preventDefault();
          if (t === 'insertText') {
            const d = e.data || '';
            if (this.isCounted(d) && this.parse().count >= this.limits().max && !this.selectionHasContent()) {
              e.preventDefault();
              this.showError(`Hai raggiunto il massimo di ${this.limits().max} lettere per la misura ${this.val('size')} cm.`);
            }
          }
          if (t === 'insertFromDrop') e.preventDefault();
        });
        this.editor.addEventListener('paste', (e) => {
          e.preventDefault();
          const text = (e.clipboardData || window.clipboardData).getData('text').replace(/[\r\n\t]+/g, ' ');
          let room = this.limits().max - this.parse().count;
          if (this.selectionHasContent()) document.execCommand('delete');
          room = this.limits().max - this.parse().count;
          let out = '';
          for (const ch of [...text]) {
            if (this.isCounted(ch)) { if (room <= 0) break; room--; }
            out += ch;
          }
          if (out) document.execCommand('insertText', false, out);
          if ([...text].filter((c) => this.isCounted(c)).length > out.length) this.showError('Testo tagliato: supera il numero massimo di lettere.');
        });
        this.editor.addEventListener('input', () => { this.cleanup(); this.update(); });

        this.grid.addEventListener('click', (e) => {
          const b = e.target.closest('.tgc__pick');
          if (b) this.insertLogo(b.dataset.id);
        });
        this.search.addEventListener('input', () => {
          const q = this.search.value.trim().toLowerCase();
          let n = 0;
          this.grid.querySelectorAll('.tgc__pick').forEach((b) => {
            const hit = !q || b.dataset.name.toLowerCase().includes(q);
            b.hidden = !hit; if (hit) n++;
          });
          this.logoEmpty.hidden = n > 0;
        });
      }

      isCounted(ch) {
        if (ch === ZW) return false;
        return this.countSpaces ? true : !/\s/.test(ch);
      }
      selectionHasContent() {
        const s = document.getSelection();
        return !!(s && s.rangeCount && !s.isCollapsed && this.editor.contains(s.anchorNode));
      }
      val(k) {
        const i = this.querySelector(`input[name^="tg_${k}_"]:checked`);
        return i ? i.value : '';
      }
      limits() {
        const i = this.querySelector('input[name^="tg_size_"]:checked');
        return { min: +i.dataset.min, max: +i.dataset.max };
      }

      /* ---------- modello testo ---------- */
      parse() {
        const tokens = []; let count = 0;
        const walk = (n) => {
          n.childNodes.forEach((c) => {
            if (c.nodeType === 3) {
              for (const ch of [...c.nodeValue]) {
                if (ch === ZW) continue;
                tokens.push({ t: 'c', v: ch });
                if (this.isCounted(ch)) count++;
              }
            } else if (c.nodeType === 1) {
              if (c.dataset && c.dataset.logo) { tokens.push({ t: 'l', id: c.dataset.logo }); count++; }
              else if (c.tagName === 'BR') { /* ignora */ }
              else walk(c);
            }
          });
        };
        walk(this.editor);
        return { tokens, count };
      }
      cleanup() {
        // niente HTML incollato/strano: lascia solo testo e chip
        this.editor.querySelectorAll('br').forEach((b) => b.remove());
        this.editor.querySelectorAll('*:not(.tgc__chip)').forEach((el) => {
          if (el.closest('.tgc__chip')) return;
          el.replaceWith(...el.childNodes);
        });
      }
      insertLogo(id) {
        const meta = this.logos[id]; if (!meta) return;
        const { max } = this.limits();
        if (this.parse().count >= max) return this.showError(`Hai raggiunto il massimo di ${max} lettere per la misura ${this.val('size')} cm.`);
        this.editor.focus({ preventScroll: true });
        const sel = document.getSelection();
        let range = this.range && this.editor.contains(this.range.startContainer) ? this.range : null;
        if (!range) { range = document.createRange(); range.selectNodeContents(this.editor); range.collapse(false); }
        sel.removeAllRanges(); sel.addRange(range);
        range.deleteContents();
        const chip = document.createElement('span');
        chip.className = 'tgc__chip'; chip.contentEditable = 'false';
        chip.dataset.logo = id; chip.title = meta.name; chip.setAttribute('aria-label', 'Logo ' + meta.name);
        chip.style.setProperty('--r', meta.r); chip.style.setProperty('--c', meta.c);
        const zw = document.createTextNode(ZW);
        range.insertNode(zw); range.insertNode(chip);
        range.setStartAfter(zw); range.collapse(true);
        sel.removeAllRanges(); sel.addRange(range);
        this.range = range.cloneRange();
        this.update();
      }

      /* ---------- validazione / aggiornamento ---------- */
      validate() {
        const { count } = this.parse();
        const { min, max } = this.limits();
        if (count === 0) return 'Scrivi il testo della tabella o aggiungi almeno un logo.';
        if (count > max) return `Hai ${count} lettere: la misura ${this.val('size')} cm ne permette al massimo ${max}. Riduci il testo o scegli una misura più grande.`;
        if (this.enforceMin && count < min) return `La misura ${this.val('size')} cm richiede almeno ${min} lettere (ora ne hai ${count}). Aggiungi lettere o scegli una misura più piccola.`;
        return '';
      }
      showError(msg) {
        this.errorEl.textContent = msg; this.errorEl.hidden = !msg;
      }

      update() {
        const { tokens, count } = this.parse();
        const { min, max } = this.limits();
        const size = this.val('size');
        const radioFont = this.querySelector('input[name^="tg_font_"]:checked');
        const radioColor = this.querySelector('input[name^="tg_color_"]:checked');

        // anteprima
                this.board.style.width = (52 + 48 * ((+size - 50) / 90)).toFixed(1) + '%';
        this.style.setProperty('--tgc-glow', radioColor.dataset.hex || '#e6f6ff');
        this.line.style.fontFamily = `'${radioFont.dataset.family}', sans-serif`;
        this.line.style.fontWeight = radioFont.dataset.weight;
        this.line.style.fontStyle = radioFont.dataset.style;
        this.line.textContent = '';
        tokens.forEach((tk) => {
          if (tk.t === 'c') this.line.append(document.createTextNode(tk.v));
          else {
            const m = this.logos[tk.id];
            const i = document.createElement('i');
            i.className = 'tgc__logo'; i.style.setProperty('--r', m.r); i.style.setProperty('--c', m.c);
            this.line.append(i);
          }
        });
        const v = this.currentVariant();
        this.dim.textContent = `${size} cm · ${this.val('power')}`;
        this.total.textContent = v ? this.money(v.price) : '';

        // contatore
        let state = 'ok', txt = `${count} / ${max} lettere`;
        if (count > max) { state = 'high'; txt += ` – ${count - max} in più`; }
        else if (count < min) { state = this.enforceMin ? 'low' : 'ok'; txt += ` – minimo ${min}`; }
        this.counter.textContent = txt; this.counter.dataset.state = count === 0 ? '' : state;
        if (!this.errorEl.hidden && !this.validate()) this.showError('');
        else if (!this.errorEl.hidden) this.showError(this.validate());

        // proprietà
        const text = tokens.map((tk) => (tk.t === 'c' ? (this.upper ? tk.v.toUpperCase() : tk.v) : `{${this.logos[tk.id].name}}`)).join('').replace(/\s+/g, ' ').trim();
        let pos = 0; const logoList = [];
        tokens.forEach((tk) => { if (tk.t === 'l') { pos++; logoList.push(`posizione ${pos}: ${this.logos[tk.id].name}`); } else if (this.isCounted(tk.v)) pos++; });
        const set = (k, v) => { const i = this.querySelector(`[data-prop="${k}"]`); if (i) i.value = v; };
        set('Misura', size + ' cm');
        set('Alimentazione', this.val('power'));
        set('Font', radioFont.value);
        set('Colore luce', radioColor.value);
        set('Testo', text);
        set('Loghi', logoList.join(', '));
        set('Lettere', String(count));
        this.fit();
      }

      fit() {
        if (!this.board || !this.board.clientWidth) return;
        const w = this.board.clientWidth * 0.88, h = this.board.clientHeight * 0.52;
        let fs = h;
        this.line.style.fontSize = fs + 'px';
        const sw = this.line.scrollWidth;
        if (sw > w) fs = fs * w / sw;
        this.line.style.fontSize = Math.max(8, Math.floor(fs)) + 'px';
      }

      /* ---------- varianti e prezzi ---------- */
      initVariants() {
        this.variants = []; this.optNames = []; this.idx = {};
        try {
          const raw = JSON.parse(this.querySelector('[data-ref="variants"]').textContent);
          this.optNames = raw.options || [];
          this.variants = raw.variants || [];
        } catch (e) { return; }
        const find = (re) => this.optNames.findIndex((n) => re.test(n));
        this.idx = { size: find(/misura|dimension|size|grandezza|larghezza/i), power: find(/aliment|volt|tensione/i) };
        const num = (s) => ((String(s).match(/\d+/) || [''])[0]);
        this.numOf = num;
        if (this.idx.size < 0 || this.variants.length < 2) { this.managed = false; return; }
        this.managed = true;
        // mostra solo le misure presenti nel prodotto
        const sizes = new Set(this.variants.map((v) => num(v.options[this.idx.size])));
        let first = null;
        this.querySelectorAll('.tgc__opt[data-size]').forEach((l) => {
          const ok = sizes.has(l.dataset.size);
          l.hidden = !ok;
          if (ok && !first) first = l;
        });
        const cur = this.querySelector('input[name^="tg_size_"]:checked');
        if (cur && cur.closest('.tgc__opt').hidden && first) first.querySelector('input').checked = true;
        // alimentazione: se il prodotto la prevede come opzione, le card si costruiscono dai suoi valori
        if (this.idx.power >= 0) {
          const first = this.querySelector('input[name^="tg_power_"]');
          const wrap = first && first.closest('.tgc__opts');
          if (wrap) {
            const name = first.name;
            const vals = [...new Set(this.variants.map((v) => v.options[this.idx.power]))];
            const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
            wrap.className = 'tgc__opts ' + (vals.length === 3 ? 'tgc__opts--3' : 'tgc__opts--2');
            wrap.innerHTML = vals.map((val, i) => `<label class="tgc__opt"><input type="radio" name="${name}" value="${esc(val)}" ${i === 0 ? 'checked' : ''}><span class="tgc__optbox"><strong>${esc(val)}</strong><em class="tgc__price" data-power-price="${esc(val)}"></em></span></label>`).join('');
          }
        }
        if (this.dataset.hidePicker !== 'false') (this.closest('.shopify-section') || document.body).classList.add('tgc-managed');
        this.renderPrices();
      }
      money(cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(cents / 100);
        } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
      }
      matchVariant(size, power) {
        const n = (s) => String(s).toLowerCase().replace(/\s+/g, '');
        return this.variants.find((v) => {
          if (this.numOf(v.options[this.idx.size]) !== size) return false;
          if (this.idx.power >= 0 && n(v.options[this.idx.power]) !== n(power)) return false;
          return true;
        });
      }
      currentVariant() {
        if (!this.managed) return null;
        return this.matchVariant(this.val('size'), this.val('power')) || null;
      }
      renderPrices() {
        if (!this.managed) return;
        const power = this.val('power'), size = this.val('size');
        this.querySelectorAll('.tgc__price[data-price-for]').forEach((el) => {
          const v = this.matchVariant(el.dataset.priceFor, power);
          el.textContent = v ? this.money(v.price) : '';
        });
        // prezzo di ogni alimentazione per la misura selezionata
        this.querySelectorAll('.tgc__price[data-power-price]').forEach((el) => {
          const v = this.matchVariant(size, el.dataset.powerPrice);
          el.textContent = v ? this.money(v.price) : '';
        });
      }

      /* ---------- selezione variante nel tema ---------- */
      syncVariant() {
        try {
          this.renderPrices();
          const v = this.currentVariant();
          if (!v) return;
          const root = this.closest('.shopify-section') || document;
          const n = (s) => String(s).toLowerCase().replace(/\s+/g, '');
          // 1) prova a usare il selettore varianti del tema, opzione per opzione
          v.options.forEach((value, i) => {
            const name = this.optNames[i];
            root.querySelectorAll('fieldset, variant-picker .variant-option, [data-option-name]').forEach((fs) => {
              if (this.contains(fs)) return;
              const label = (fs.querySelector('legend')?.textContent || fs.dataset.optionName || '').trim().toLowerCase();
              if (label !== String(name).trim().toLowerCase()) return;
              const hit = [...fs.querySelectorAll('input[type="radio"]')].find((r) => n(r.value) === n(value));
              if (hit && !hit.checked) hit.click();
              const sel = fs.querySelector('select');
              if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
            });
          });
          // 2) rete di sicurezza: se l'id nel modulo non è quello giusto, lo imposto
          setTimeout(() => {
            const idEl = this.form && this.form.querySelector('[name="id"]');
            if (idEl && String(idEl.value) !== String(v.id)) {
              if (idEl.tagName === 'SELECT' && ![...idEl.options].some((o) => o.value === String(v.id))) return;
              idEl.value = String(v.id);
              idEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }, 250);
        } catch (e) { /* facoltativo */ }
      }
    }

    customElements.define('tg-sign-configurator', TgSignConfigurator);
  })();
  } catch(e) { console.error(e); }
})();

})();
